module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Author’s preface")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Haggai, Zechariah and Malachi preached to audiences who were jaded by the lack of relevance of organized religion to their daily economic and social life. They were self-absorbed, preoccupied with personal agendas, bent on comparing themselves with others, questioning the fairness of life, looking for an edge, pursuing material rather than spiritual things, morally ambivalent, apathetic with respect to civil responsibility, hypocritical with regard to religious practice, chasing much but grasping little – and the list goes on. Sound familiar?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The crisis of relevance persists today in numerous ways and at a variety of levels. Our three prophets sought to remedy the crisis of the relevance of the religion of YHWH for the people of God living in post-exilic Judah by calling them to "), _c('i', [_vm._v("return to God ")]), _vm._v("(Zech. 1:3; Mal. 3:7). Much of the teaching of Haggai, Zechariah and Malachi still has currency for the people of God dealing with the various crises of relevance in our contemporary culture. Their sermons remain an open invitation to "), _c('i', [_vm._v("be still before the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")])]), _vm._v("(Zech. 2:13), "), _c('i', [_vm._v("to seek the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("Almighty ")]), _vm._v("(Zech. 8:22), and to come to understand and acknowledge that YHWH is "), _c('i', [_vm._v("a great king ")]), _vm._v("(Mal. 1:14). In short, they continue to call us to return to God – godly repentance is always relevant.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("I am honoured to stand on the shoulders of such an able scholar as the late Joyce G. Baldwin. Over the years, I have personally and professionally benefited from her TOTC commentaries, first as a seminarian, later as a graduate student, and now as a professor of ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("biblical studies. As a credit to her careful and insightful scholarship, I have intentionally made wide appeal to her analysis, where appropriate. I trust this iteration of the TOTC on the books of Haggai, Zechariah and Malachi will serve the next generation of students and pastor-teachers equally well.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The New International Version ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")]), _vm._v(") is the baseline English translation used for the commentary, and quotations from this version are given in italics. Other English versions are referenced where helpful, including the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIV ")]), _vm._v("2011 edition when pertinent. Bible translation is necessarily interpretive in many instances, so the broad engagement with an array of English versions brings both breadth of perspective and depth of understanding to the analysis of particular verses of Scripture. Numerous insightful and readable commentaries are available on the books of Haggai, Zechariah and Malachi. I have benefited from this excellent scholarship and have attempted to interact with these resources (cited in the Select bibliography for each book) in such a way that the reader gains an understanding of the biblical text, informed by a variety of voices.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Special attention is given to intertextual relationships in our analysis, since each of the three prophets often appeal (whether directly or indirectly) to the messages of their earlier counterparts. We read the Bible as theology (the "), _c('i', [_vm._v("revelation ")]), _vm._v("of God and his redemptive plan for humanity), history (the "), _c('i', [_vm._v("record ")]), _vm._v("of God’s dealings with humanity, and especially Israel) and literature (the "), _c('i', [_vm._v("story ")]), _vm._v("of God and human experience). All three lenses are employed in our analysis of Haggai, Zechariah and Malachi. Emphasis is given to literary analysis of our three prophetic books, since each is a hybrid of sorts, combining a distinctive mix of genres and literary features in their sermons and visions to post-exilic Judah. This approach also assumes the books of Haggai, Zechariah and Malachi have some inherent relationship by way of theme(s) and message, since they arise out of the same general period of history and address the same constituency. This reading of the three post-exilic prophets also recognizes that they belong to a larger collection of prophetic books, the Book of the Twelve (or Minor Prophets), which may tell a more extended story about God and his people Israel.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("By way of acknowledgments, I would like to thank my graduate assistants, Brett Blum and Jordan Brown, for their work in the ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("process of compiling the manuscript for this commentary. I am indebted to the staff of IVP UK for their good work in seeing the volume through to publication. I would especially like to recognize Philip Duce (Senior Commissioning Editor) for the opportunity to contribute to this venerable commentary series. I offer my thanks as well to David Firth (Series Editor) for ably bringing this instalment of the TOTC to completion. I am grateful to both for their patience, professionalism and scholarly insight as overseers of the project.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("I remain grateful for Teri, the wife of my youth. Thanks to her partnership, I am coming to understand more clearly, and practise more intentionally, the prophetic call to do justice and to love mercy. We look forward to the realization of Zechariah’s vision of streets filled with boys and girls playing in safety – for our three (now grown-up) children, our several grandchildren, and for all children (Zech. 8:4–5).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("To the reader, listen and learn from the preaching of these last three voices of the OT prophetic movement. Haggai reminds us to ‘think carefully about our behaviour’ (Hag. 1:5, 7; 2:15, 18, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NJB")]), _vm._v("). Zechariah exhorts us not to despise ‘small beginnings’ (Zech. 4:10, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLT")]), _vm._v("), since "), _c('i', [_vm._v("it is not by might nor by power, but by the Spirit ")]), _vm._v("that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("Almighty accomplishes his purposes (Zech. 4:6). And finally, Malachi encourages the people of God by affirming that, ‘“I have always loved you,” says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’ (Mal. 1:2, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLT")]), _vm._v(").")])]), _c('p', {
    staticClass: "sign"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Andrew E. Hill"), _c('br'), _vm._v("Wheaton College"), _c('br'), _vm._v("Wheaton, Illinois"), _c('br'), _vm._v("Advent 2011")])])])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 72
// module chunks = 0